import Grid from "@mui/material/Grid";
import ValidatorSelectField from "@/src/components/FormFields/ValidatorSelectField";
import { emailDefault, isPhoneNumberDefault, requiredValidator } from "@/src/services/validationRules";
import MenuItem from "@mui/material/MenuItem";
import ValidatorTextField from "@/src/components/FormFields/ValidatorTextField";
import ButtonLoading from "@/src/components/Button/ButtonLoading";
import DialogModal from "@/src/components/DialogModal/DialogModal";
import EmailChange from "@/src/components/LoginForm/EmailChange";
import React from "react";
import { useForm } from "@/src/provider/Form/FormProvider";
import { Stack } from "@mui/material";

type PersonalDataFormProps = {
  isEmailModalOpen: boolean;
  setIsEmailModalOpen: (isEmailModalOpen: boolean) => void;
  newEmailAddress: string;
  isLoading: boolean;
};

export default function PersonalDataForm({ isEmailModalOpen, setIsEmailModalOpen, isLoading, newEmailAddress }: PersonalDataFormProps) {
  const { handleSubmit } = useForm();
  return (
    <>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <ValidatorSelectField
              displayEmpty
              label={"Anrede"}
              name={"gender"}
              MenuProps={{ slotProps: { paper: { style: { maxHeight: 200 } } } }}
            >
              <MenuItem value={""}>Keine Anrede</MenuItem>
              <MenuItem value={"female"}>Frau</MenuItem>
              <MenuItem value={"male"}>Herr</MenuItem>
            </ValidatorSelectField>
          </Grid>
        </Grid>
        <Grid
          container
          columnSpacing={2}
          rowSpacing={0}
          sx={{
            justifyContent: "center",
          }}
        >
          <Grid size={{ xs: 12, md: 6 }}>
            <ValidatorTextField name="givenName" label="Vorname" validators={[requiredValidator("Bitte geben Sie Ihren Vornamen an")]} />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <ValidatorTextField name="familyName" label="Nachname" validators={[requiredValidator("Bitte geben Sie Ihren Nachnamen an")]} />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <ValidatorTextField
              name="telephone"
              label="Ihre Telefonnummer"
              autoComplete="tel"
              validators={[requiredValidator("Bitte geben Sie Ihre Telefonnummer an"), ...isPhoneNumberDefault]}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <ValidatorTextField
              name="email"
              label="Ihre E-Mail-Adresse"
              validators={[requiredValidator("Bitte geben Sie Ihre E-Mail-Adresse an"), emailDefault]}
            />
          </Grid>
          <Grid size={12}>
            <Stack direction={"row"} sx={{ justifyContent: { md: "flex-end" }, marginTop: { xs: "1rem", md: "0.5rem" } }}>
              <ButtonLoading type="submit" variant={"contained"} color={"primary"} isLoading={isLoading} sx={{ width: { xs: "100%", md: "auto" } }}>
                Speichern
              </ButtonLoading>
            </Stack>
          </Grid>
        </Grid>
      </form>
      <DialogModal open={isEmailModalOpen} onClose={() => setIsEmailModalOpen(false)} title={"E-Mail-Adresse ändern"} responsive={true}>
        <EmailChange newEmail={newEmailAddress} handleClose={() => setIsEmailModalOpen(false)} />
      </DialogModal>
    </>
  );
}
